"use strict";

function helper(Handlebars) {
  /**
   * Subtract numbers. Ignore NaN.
   *
   * {{subtract 1 2}} returns -1
   * {{subtract -1 2}} returns -3
   * {{subtract "1" 2}} return -1
   * {{subtract 1.5 1}} returns .5
   * {{subtract 1 2 3}} returns -4
   *
   * @return {Number} sequential subtraction of all passed arguments
   */
  function subtract() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var numbers = Array.prototype.slice.call(args, 1, -1);
    var result = parseFloat(args[0], 10);
    for (var i = numbers.length - 1; i >= 0; i -= 1) {
      result -= parseFloat(numbers[i], 10) || 0;
    }
    return String(result);
  }
  Handlebars.registerHelper('subtract', subtract);
  return subtract;
}
module.exports = helper;
